import { COLORS, FlexColumn } from 'modules/ui/components';
import styled from 'styled-components';

export const StyledOfficeWrapper = styled(FlexColumn)`
  border-bottom: 1px solid ${COLORS.lightBlue};
`;
